import React from 'react';

import { NavLink } from 'react-router-dom';

type Link = {
  name: string;
  path: string;
};

type Props = {
  items: Link[];
  basePath?: string;
};

export const Navigation: React.FC<Props> = ({ items, basePath }) => {
  return (
    <ul className="navigation">
      {items.map((item) => (
        <NavLink
          key={item.path}
          to={basePath && !item.path.startsWith('/') ? `${basePath}/${item.path}` : item.path}
          className={({ isActive }) => (isActive ? 'navigation__link navigation__link-active' : 'navigation__link')}
        >
          {item.name}
        </NavLink>
      ))}
    </ul>
  );
};
